import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home';

Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home,
    // },
    {
      path: '/',
      redirect: '/builder/kitchen',
    },
    {
      path: '/builder/:type/:base?/:overlay?',
      name: 'builder',
      component: () =>
        import(/* webpackChunkName: "builder" */ './views/Builder'),
    },
    {
      path: '*',
      component: () =>
        import(/* webpackChunkName: "notfound" */ './views/NotFound'),
    },
  ],
});
